import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React from 'react'
import Slider from "react-slick";
const OurPartners = () => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    };
    return (
        <div className="integration-area section-spacing">
            <div className="container">
                <div className="integration-area-inner mt-10">
                    <div className="section-header">
                        <div className="section-title-wrapper">
                            <div className="title-wrapper">
                                <h2 className="section-title has_fade_anim  text-grad-1 fs-4x">
                                    Our Customers
                                </h2>
                                <div className="section-title has_fade_anim  text-grad-3 fs-1 mt-2 lh-2">
                                    Our customers are trusted collaborators who drive innovation and success through shared expertise and vision
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="integration-cards-wrapper tv-partner mt-20">
                        <div className="tab-content" id="pills-tabContent">
                            <div className="tab-pane fade show active" id="pills-first" role="tabpanel" aria-labelledby="pills-first-tab" tabIndex="0">
                                <Slider {...settings}>
                                    <div>
                                        <img src="/assets/img/partner/centa.jpg" alt="Centa" />
                                    </div>
                                    <div>
                                        <img src="/assets/img/partner/tvguide.jpg" alt="TV Guide" />
                                    </div>
                                    <div>
                                        <img src="/assets/img/partner/imprzd.jpg" alt="Imprzd" />
                                    </div>
                                    <div>
                                        <img src="/assets/img/partner/espired.jpg" alt="Espired" />
                                    </div>
                                    <div>
                                        <img src="/assets/img/partner/fintosh.jpg" alt="Fintosh" />
                                    </div>
                                    <div>
                                        <img src="/assets/img/partner/modi.jpg" alt="Modi Properties" />
                                    </div>
                                    <div>
                                        <img src="/assets/img/partner/lipo.jpg" alt="Lipozene" />
                                    </div>
                                    <div>
                                        <img src="/assets/img/partner/yoga.jpg" alt="Yoga" />
                                    </div>
                                    <div>
                                        <img src="/assets/img/partner/tmp.jpg" alt="TMP" />
                                    </div>
                                    <div>
                                        <img src="/assets/img/partner/vcard.jpg" alt="vCard" />
                                    </div>                                                
                                    <div>
                                        <img src="/assets/img/partner/zipgrid.jpg" alt="Zipgrid" />
                                    </div>
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export {OurPartners}